import { render } from "./document_warehouse.html?vue&type=template&id=d8545176&external"
import script from "./document_warehouse.js?vue&type=script&lang=js&external"
export * from "./document_warehouse.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__